export default __webpack_public_path__ + "static/ewallet-app-development-company-peerbits-041d025d4929da4e35d3b5e03ce220a9.png";